import { auditService } from "@/stores/services/auditService";
import { skipToken } from "@reduxjs/toolkit/query";

export function useFleetData(companyId: number, auditId?: number) {
  const { data: fleetByCompany, isFetching: isLoadingFleetByCompany } =
    auditService.useFindFleetsByCompanyIdQuery(
      auditId && auditId > 0 ? { companyId, auditId } : skipToken,
    );

  return {
    fleetByCompany,
    isLoadingFleetByCompany,
  };
}
